import { optionsFunction } from "./_config";
import axios from "axios";

// SeasonPass API.

export const getSeasonPassActive = () =>
  axios
    .get(`/api/v2/season-pass/active`, optionsFunction())
    .then((res) => res.data.data);

export const getSeasonPassById = (id) =>
  axios
    .get(`/api/v2/season-pass/${id}`, optionsFunction())
    .then((res) => res.data.data);

export const getSeasonPassUserById = (id) =>
  axios
    .get(`/api/v2/season-pass/user/${id}`, optionsFunction())
    .then((res) => res.data.data);

export const getSeasonPassRewardsById = (id) =>
  axios
    .get(`/api/v2/season-pass/rewards/${id}`, optionsFunction())
    .then((res) => res.data.data);

export const getSeasonPassUserTiers = (id) =>
  axios
    .get(`/api/v2/season-pass/user/${id}/tiers`, optionsFunction())
    .then((res) => res.data.data);

export const seasonPassPurchaseTier = (id, tier) =>
  axios
    .post(
      `/api/v2/season-pass/tier/${id}/${tier}`,
      { id: id, tier: tier },
      optionsFunction()
    )
    .then((res) => res.data.data);

export const seasonPassPurchaseLevel = (id, level) =>
  axios
    .post(
      `/api/v2/season-pass/level/${id}/${level}`,
      { id: id, level: level },
      optionsFunction()
    )
    .then((res) => res.data.data);
